/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { Table } from "../../../components/table-components/Table";
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { TableBody } from "../../../components/table-components/TableBody";
import { Product } from "../models/product";
import { TableRow } from "../../../components/table-components/TableRow";
import { TableCellText } from "../../../components/table-components/TableCellText";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { ProductPackingItemsDropdown } from "./ProductPackingItemsDropdown";
import { css } from "@emotion/react";
import { UpdateProductDrawer } from "./UpdateProductDrawer";

type Props = {
  product: Product;
};

const dropdownWrapperStyle = css`
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`;

export const ProductPackingItemsTable = ({ product }: Props) => {
  const [packingItemToEdit, setPackingItemToEditId] = useState<string>("");

  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText>Name</TableCellHeaderText>
          <TableCellHeaderText>
            Display name (Visible on receipt)
          </TableCellHeaderText>
          <TableCellHeaderText>Receipt setting</TableCellHeaderText>
          <TableCellHeaderText>Kitchen category</TableCellHeaderText>
          <TableCellHeaderText>Amount</TableCellHeaderText>
          <TableCellHeaderText>Unit</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {(product.packagingInstructions || []).map((ing, i) => {
          return (
            <React.Fragment key={ing.id}>
              <TableRow>
                <TableCellText
                  className="pl-5"
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.name}
                  </StyledText>
                </TableCellText>
                <TableCellText
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.title}
                  </StyledText>
                </TableCellText>
                <TableCellText
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.receiptSetting}
                  </StyledText>
                </TableCellText>
                <TableCellText
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.category.name}
                  </StyledText>
                </TableCellText>
                <TableCellText
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.amount}
                  </StyledText>
                </TableCellText>
                <TableCellText
                  onClick={() => {
                    setPackingItemToEditId(ing.id);
                  }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextRegular mb-0"
                  >
                    {ing.unit || "-"}
                  </StyledText>
                </TableCellText>
                <td css={dropdownWrapperStyle}>
                  <ProductPackingItemsDropdown
                    setPackingItemToEditId={setPackingItemToEditId}
                    id={ing.id}
                    product={product}
                  />
                </td>
              </TableRow>
              <UpdateProductDrawer
                drawerTitle="Update packing items"
                isOpen={packingItemToEdit === ing.id}
                handleOnClose={() => {
                  setPackingItemToEditId("");
                }}
                product={product}
                type="packing_item_edit"
                packingItemIndex={i}
              />
            </React.Fragment>
          );
        })}
      </TableBody>
    </Table>
  );
};
